export const LAST_BROWSE_SHOT_STORAGE_KEY = "story37.lastBrowseShot";
export const LAST_BROWSE_SHOT_CHANNEL = "story37.lastBrowseShot";
export const BROWSE_SHOT_HISTORY_STORAGE_KEY = "story37.browseShotHistory";
export const BROWSE_SHOT_HISTORY_LIMIT = 100;

export type LastBrowseShot = {
  shotId: number;
  videoId: number;
  shotNo: number;
  durMs: number;
  width: number;
  height: number;
  thumbUrl: string;
  videoUrl: string;
  ts: number;
};

function finitePositiveInt(value: unknown) {
  const parsed = Math.trunc(Number(value));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

function finiteNonNegativeInt(value: unknown) {
  const parsed = Math.trunc(Number(value));
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
}

export function normalizeLastBrowseShot(value: unknown): LastBrowseShot | null {
  if (!value || typeof value !== "object") {
    return null;
  }
  const item = value as Partial<LastBrowseShot>;
  const shotId = finitePositiveInt(item.shotId);
  const videoId = finitePositiveInt(item.videoId);
  if (!shotId || !videoId) {
    return null;
  }
  return {
    shotId,
    videoId,
    shotNo: finitePositiveInt(item.shotNo),
    durMs: finiteNonNegativeInt(item.durMs),
    width: finiteNonNegativeInt(item.width),
    height: finiteNonNegativeInt(item.height),
    thumbUrl: typeof item.thumbUrl === "string" ? item.thumbUrl : "",
    videoUrl: typeof item.videoUrl === "string" ? item.videoUrl : "",
    ts: finiteNonNegativeInt(item.ts)
  };
}

export function normalizeBrowseShotHistory(value: unknown): LastBrowseShot[] {
  if (!Array.isArray(value)) return [];
  const seen = new Set<number>();
  return value.flatMap((entry) => {
    const shot = normalizeLastBrowseShot(entry);
    if (!shot || seen.has(shot.shotId)) return [];
    seen.add(shot.shotId);
    return [shot];
  }).sort((left, right) => right.ts - left.ts).slice(0, BROWSE_SHOT_HISTORY_LIMIT);
}

export function formatLastBrowseShotDuration(ms: number) {
  if (!ms || ms <= 0) {
    return "motion";
  }
  const seconds = ms / 1000;
  return seconds < 10 ? `${seconds.toFixed(1)}s` : `${Math.round(seconds)}s`;
}
